import { createReducer } from '@reduxjs/toolkit';

import { StatisticsDownloadInit } from 'redux/reducers/init';

import {
  requestStatisticsDownload,
  requestStatisticsDownloadSuccess,
  requestStatisticsDownloadFailure,
} from 'redux/actions/statistics/actions';

/**
 * Reducers
 */
const statisticsDownload = createReducer(StatisticsDownloadInit, {
  [requestStatisticsDownload.type]: (state, action: RequestStatisticsDownloadAction) => {
    state.isLoading = true;
  },
  [requestStatisticsDownloadSuccess.type]: (
    state,
    action: RequestStatisticsDownloadSuccessAction,
  ) => {
    const { statisticsDownload } = action.payload;
    state.isLoading = false;
    state.statistics = statisticsDownload;
  },
  [requestStatisticsDownloadFailure.type]: (
    state,
    action: RequestStatisticsDownloadFailureAction,
  ) => {
    state.isLoading = false;
    state.statistics = [];
  },
});

export default statisticsDownload;
